var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-icon',{attrs:{"color":"blue","type":"check-circle"}}),_c('m-icon',{attrs:{"color":"blue","type":"search"}}),_c('m-icon',{attrs:{"type":"fail"}}),_c('m-icon',{attrs:{"type":"loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }